import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        chartList: [],
        range: [],
		pager: {},
        loading: false,
        dashboard: {}
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 获取手机搜索列表
		async getGeneral({ commit }: any) {
			const res = await fetch({
				url: '/client/dashboard/general'
			})
            commit('setState',{key:'dashboard',data: res})
            
        },
        // 获取手机搜索列表
		async getInventory({ commit }: any, params: any) {
            commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/client/dashboard/inventory',
                params
			})
            commit('setState',{key:'chartList',data: res.chart})
            commit('setState',{key:'range',data: res.range})
            commit('setState',{key:'loading',data: false})
		},
		// 获得消息通知
		async getNotice({ commit }: any) {
			const res:any = await fetch({
                url: '/client/notice'
			})
            return res
		},
		// 获得消息通知详情
		async getNoticeDetail({ commit }: any,id:string) {
			const res:any = await fetch({
                url: `/client/relevancyapply/${id}`
			})
            return res
		},
		// 提交关联店铺审核
		async auditDetail({ commit }: any, params: any) {
			const res:any = await fetch({
				url: `/client/relevancyapply/${params.id}`,
				method: 'put',
				data: params.data
			})
            return res
		},
	}
}